!function() {
  "use strict";
  
  const selectors = {
    tickerScale: "[data-ticker-scale]",
    tickerText: "[data-ticker-text]",
    dataClone: "data-clone",
    autoplay: "autoplay",
    speed: "speed",
    tickerAnimated: "ticker--animated",
    tickerUnloaded: "ticker--unloaded",
    tickerComparitor: "ticker__comparitor"
  };
  
  const constants = {
    defaultSpeed: 1.63,
    speedMultiplier: 100
  };
  
  if (!customElements.get("ticker-bar")) {
    customElements.define("ticker-bar", class extends HTMLElement {
      constructor() {
        super();
        
        this.autoplay = this.hasAttribute(selectors.autoplay);
        this.enableDesktopScroll = this.hasAttribute("data-enable-desktop-scroll");
        this.scale = this.querySelector(selectors.tickerScale);
        this.text = this.querySelector(selectors.tickerText);
        this.speed = this.hasAttribute(selectors.speed) 
          ? this.getAttribute(selectors.speed) 
          : constants.defaultSpeed;
        
        // Create comparitor for width checking
        this.comparitor = this.text.cloneNode(true);
        this.comparitor.classList.add(selectors.tickerComparitor);
        this.appendChild(this.comparitor);
        
        this.scale.classList.remove(selectors.tickerUnloaded);
        this.checkWidthEvent = this.checkWidth.bind(this);
      }
      
      connectedCallback() {
        this.checkWidth();
        
        this.addEventListener("theme:ticker:refresh", 
          window.theme.debounce(() => this.checkWidthEvent(), 50)
        );
        
        if (screen.orientation) {
          screen.orientation.addEventListener("change", this.checkWidthEvent);
        }
        
        document.addEventListener("theme:resize:width", this.checkWidthEvent);
      }
      
      disconnectedCallback() {
        document.removeEventListener("theme:resize:width", this.checkWidthEvent);
      }
      
      checkWidth() {
        this.text = this.querySelector(selectors.tickerText);
        
        const padding = 2 * parseInt(window.getComputedStyle(this).paddingLeft.replace("px", ""));
        const needsScrolling = this.clientWidth - padding < this.comparitor.clientWidth;
        
        // Check if we should enable scrolling based on device and settings
        const isMobile = window.innerWidth <= 749;
        const shouldScroll = this.autoplay && (isMobile || this.enableDesktopScroll);
        
        if (needsScrolling || shouldScroll) {
          this.text.classList.remove(selectors.tickerAnimated);
          
          // Remove existing clones
          const existingClones = this.scale.querySelectorAll(`[${selectors.dataClone}]`);
          existingClones?.forEach(clone => clone.remove());
          
          // Add new clones if autoplay or needs scrolling
          if (this.autoplay || needsScrolling) {
            const cloneCount = this.autoplay 
              ? parseInt((window.innerWidth - padding) / this.text.clientWidth) 
              : 2;
            
            for (let i = 0; i <= cloneCount; i++) {
              const clone = this.text.cloneNode(true);
              clone.setAttribute(selectors.dataClone, "");
              this.scale.appendChild(clone);
            }
          }
          
          // Calculate animation time
          const animationTime = (this.text.clientWidth / constants.speedMultiplier * Number(this.speed)).toFixed(2);
          
          this.scale.style.removeProperty("--animation-time");
          this.scale.style.setProperty("--animation-time", `${animationTime}s`);
          
          // Add animation class to all text elements
          this.scale.querySelectorAll(selectors.tickerText)?.forEach(text => {
            text.classList.add(selectors.tickerAnimated);
          });
        } else {
          // No scrolling needed
          this.text.classList.add(selectors.tickerAnimated);
          
          // Remove clones
          this.scale.querySelectorAll(`[${selectors.dataClone}]`).forEach(clone => {
            clone.parentNode.removeChild(clone);
          });
          
          this.text.classList.remove(selectors.tickerAnimated);
        }
      }
    });
  }
}();
